import { BusinessUnitShort } from 'src/@enums'
import { gaEvent, getBusinessUnitDescribed } from 'src/utils'

/**
 * Parâmetro para {@link bankAccountNotExistEvent}
 */
export type BankAccountNotExist = {
  label: string
  businessUnit: `${BusinessUnitShort}`
}

/**
 * [TARGET]: adicionar uma conta bancária
 *
 * [CONTEXTO]: deve ser utilizado no cadastro de uma nova conta bancária
 *
 * [REGRAS]: n/a
 *
 * @param config - Objeto com dados do evento
 */
export const bankAccountNotExistEvent = ({ label, businessUnit }: BankAccountNotExist) => {
  const businessUnitDescribed = getBusinessUnitDescribed(businessUnit)
  const baseEvent = {
    event: 'ga-event',
    'event-category': `pagamentos-sellout:${businessUnitDescribed}:geral`,
    'event-action': 'click:button',
  }
  gaEvent({ ...baseEvent, 'event-label': label })
}
